module.exports = require("./ar-JO.d.ts");